import React, { useState, useEffect, useRef } from 'react';
import AppLayout from '../../../../../layout/components/AppLayout';
import CompanySelectComponent from '../components/CompanySelectComponent';
import { useAppData } from '../../../../../context/AppDataContext';
import { Autocomplete, TextField } from '@mui/material';
import EmployeIDCard from '../components/EmployeIDCardPrint';
import { useReactToPrint } from 'react-to-print';

function EmployeePrintIdCardPage() {
    const printComponentRef = useRef();
    const [companyDetails, setCompanyDetails] = useState(null);
    const { employeeList, getEmployeeList } = useAppData();
    const [selectedEmploye, setSelectedEmployee] = useState(null);
    const [selectedEmployeeList, setSelectedEmployeeList] = useState([]);

    const updateSelectedEmployeeList = () => {
        if (selectedEmploye && !selectedEmployeeList.some(e => e.id === selectedEmploye.id)) {
            setSelectedEmployeeList([...selectedEmployeeList, selectedEmploye]);
            setSelectedEmployee(null);
        }
    };

    useEffect(() => {
        getEmployeeList();
    }, []);

    const handlePrint = useReactToPrint({
        content: () => printComponentRef.current,
        // Standard A4 or Letter size logic
        pageStyle: `
            @page { 
                size: auto; 
                margin: 10mm; 
            }
            @media print {
                body { -webkit-print-color-adjust: exact; }
                .id-card-wrapper { 
                    break-inside: avoid; 
                    page-break-inside: avoid; 
                    margin-bottom: 20px; /* Space between rows for cutting */
                }
            }
        `
    });

    return (
        <AppLayout>
            <style>
                {`
                    .print-container {
                        display: grid;
                        grid-template-columns: repeat(2, 1fr);
                        gap: 30px; /* Horizontal and Vertical spacing for cutting */
                        padding: 10px;
                    }
                    @media screen {
                        .print-preview-box {
                            border: 1px dashed #ccc;
                            margin-top: 20px;
                            background: #f9f9f9;
                        }
                    }
                `}
            </style>

            <div className='container-fluid py-4'>
                <div className='row align-items-center mb-4'>
                    <div className='col-md-4'>
                        <Autocomplete
                            options={employeeList || []}
                            getOptionLabel={(option) => `${option.employeeName} ${option.employeeCode ? `(${option.employeeCode})` : ""}`}
                            onChange={(event, newValue) => setSelectedEmployee(newValue)}
                            value={selectedEmploye}
                            renderInput={(params) => <TextField {...params} label="Select Employee" size="small" />}
                        />
                    </div>
                    <div className='col-md-1'>
                        <button className='btn btn-primary w-100' onClick={updateSelectedEmployeeList}>Add</button>
                    </div>
                    <div className='col-md-4'>
                        <CompanySelectComponent setCompanyDetails={setCompanyDetails} />
                    </div>
                    <div className='col-md-2'>
                        <button className='btn btn-success w-100' onClick={handlePrint}>Print All</button>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-12'>
                        <h5 className='mb-3'>Print Preview</h5>
                        <div className='print-preview-box'>
                            <div ref={printComponentRef} className="print-container">
                                {selectedEmployeeList.map((employeDetails, index) => (
                                    employeDetails && companyDetails && (
                                        <div key={index} className="id-card-wrapper">
                                            <EmployeIDCard 
                                                employeDetails={employeDetails} 
                                                companyDetails={companyDetails} 
                                            />
                                        </div>
                                    )
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
}

export default EmployeePrintIdCardPage;